import ResponsiveHeader from "../responsiveheader/ResponsiveHeader.vue"
import ResponsiveFooter from "../responsivefooter/ResponsiveFooter.vue"
export default {
  name: 'assetSelector',
  components: {
    responsiveheader: ResponsiveHeader,
    responsivefooter: ResponsiveFooter
  },
  props: [],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
}


